// extracted by mini-css-extract-plugin
export default {"form":"AdminConfigModal_form__o09aO"};